import { Bar, Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
  Title,
  Filler,
} from "chart.js";
import HelmetTags from "../../../../MainComponents/HelmetTags";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import useTable from "../../../../MainComponents/Hooks/useTable";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWatchmanMonitoring } from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import { faUsers } from "@fortawesome/free-solid-svg-icons";

ChartJS.register(
  LineElement,
  BarElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Legend,
  Tooltip,
  Title,
  Filler
);

function Analytics() {
  const [stageCount, setStageCount] = useState([]);
  const [months, setMonths] = useState([]);
  const [stage1, setStage1] = useState([]);
  const [stage2, setStage2] = useState([]);
  const [stage3, setStage3] = useState([]);
  const table = useTable("analytics", "", "");
  const [analyticsData, analyticsDataErrors, analyticsDataLoading] = useAxios(
    process.env.REACT_APP_ADMIN_ANALYTICS_API,
    "GET",
    "GET",
    "",
    ""
  );
  const [analyticsBar, analyticsBarErrors, analyticsBarLoading] = useAxios(
    process.env.REACT_APP_ANALYTICS_GRAPH_API,
    "GET",
    "GET",
    "",
    ""
  );
  const labels = months;

  const data = {
    labels,
    datasets: [
      {
        label: "1st sec",
        data: stage1,
        backgroundColor: "#4285f4",
        borderColor: "#4285f4",
        pointBorderColor: "#4285f4",
        //fill:true,
        tension: 0.4,
      },
      {
        label: "2nd sec",
        data: stage2,
        backgroundColor: "rgb(110, 231, 183)",
        borderColor: "rgb(110, 231, 183)",
        pointBorderColor: "rgb(110, 231, 183)",
        //fill:true,
        tension: 0.4,
      },
      {
        label: "3rd sec",
        data: stage3,
        backgroundColor: "rgba(189, 19, 236)",
        borderColor: "rgba(189, 19, 236)",
        pointBorderColor: "rgba(189, 19, 236)",
        //fill:true,
        tension: 0.4,
      },
    ],
  };
  const DoughnutData = {
    labels: ["1st sec", "2nd sec", "3rd sec"],
    datasets: [
      {
        label: "Stages",
        data: stageCount,
        backgroundColor: [
          "#4285f4",
          "rgb(110, 231, 183)",
          "rgba(189, 19, 236)",
        ],
        borderColor: [
          "rgba(3, 65, 221, 1)",
          "rgb(110, 231, 183,1)",
          "rgba(189, 19, 236, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  const options = {
    responsive: true,

    plugins: {
      legend: true,
    },
    title: {
      display: true,
      text: "Chart.js Line Chart",
    },
    scales: {
      y: {},
    },
  };

  useEffect(() => {
    setStageCount((prev) =>
      analyticsData?.data.stagecount.map((count) => count.count)
    );
  }, [analyticsData]);

  useEffect(() => {
    setMonths((prev) => analyticsBar?.data.map((item) => item.month));
    setStage1((prev) => analyticsBar?.data.map((item) => item.stage_one));
    setStage2((prev) => analyticsBar?.data.map((item) => item.stage_two));
    setStage3((prev) => analyticsBar?.data.map((item) => item.stage_three));
  }, [analyticsBar]);

  return (
    <section className="dark:bg-dark dark:text-light h-full w-full overflow-y-auto px-10 py-10 sm:px-4">
      <HelmetTags title="Analytics | Mr.Mohamed Salama"></HelmetTags>{" "}
      <h2 className="mb-7 text-start text-2xl font-bold sm:text-center">
        Analytics
      </h2>
      <div className="gap-4 items-center py-5 flex w-full flex-wrap">
        <Link
          to="/admin/analytics/toptenwrong"
          className=" rounded-lg border-2 border-[#f87171] bg-[#f87171] px-2 py-1 font-semibold text-white transition-all duration-300 hover:bg-bg hover:text-delete   active:scale-90 "
        >
          <FontAwesomeIcon icon={faWatchmanMonitoring} /> Top Wrong Question
        </Link>
        <Link
          to="/admin/analytics/topwrongstudents"
          className=" rounded-lg border-2 border-[#f87171] bg-[#f87171] px-2 py-1 font-semibold text-white transition-all duration-300 hover:bg-bg hover:text-delete   active:scale-90 "
        >
          <FontAwesomeIcon icon={faUsers} /> Top Wrong Students
        </Link>
        <Link
          to="/admin/analytics/topresultsstudents"
          className=" rounded-lg border-2 border-secondary bg-secondary px-2 py-1 font-semibold text-white transition-all duration-300 hover:bg-bg hover:text-secondary   active:scale-90 "
        >
          <FontAwesomeIcon icon={faUsers} /> Top Results Students
        </Link>
      </div>
      <div
        //!container
        className="lef-right-container flex h-fit w-full items-start justify-between gap-12 lg:flex-col lg:items-center lg:justify-start lg:gap-20 "
      >
        <div
          //!left
          className="admin-dash-left flex  h-fit w-1/2 flex-col items-start justify-start gap-8 lg:w-full lg:items-center "
        >
          <div className="line-chart  flex max-h-[310px] w-full flex-col items-start justify-start gap-4  lg:items-center xs:w-[80%]">
            <Doughnut data={DoughnutData}></Doughnut>
          </div>
        </div>

        <div
          //!right
          className="admin-dash-right flex  h-fit w-1/2 flex-col items-end justify-start lg:w-full  lg:items-center "
        >
          <div className="bar-chart mt-20 flex h-52 w-full flex-col items-start justify-start gap-4 lg:items-center xs:w-[80%]">
            <Bar className="" data={data} options={options}></Bar>
          </div>
        </div>
      </div>
      <div className="h-fit  w-full">{table}</div>
    </section>
  );
}

export default Analytics;
